import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { VALIDATION_RULES } from '../constants/validation-rules';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  rules = VALIDATION_RULES;

  hasError(formGroup: UntypedFormGroup, controlName: string, errorName: string): boolean {
    return formGroup.controls[controlName].hasError(errorName);
  }

  hasMaxLengthError(formGroup: UntypedFormGroup, controlName: string, maxLength: number): boolean {
    const control = formGroup.controls[controlName];
    return control.hasError('maxlength') && control.errors?.maxlength?.requiredLength === maxLength;
  }
}
